import type { CatalogTree } from '../types';

export const adapters = {
  title: 'Adaptörler',
  console: 'Simülatör konsolu',
  empty: 'Kayıtlı adaptör yok.',
  port: {
    channel: 'Kanal',
    store: 'Mağaza',
    engine: 'Motor',
    chat: 'Sohbet modeli',
    vision: 'Görüntü modeli',
    embedding: 'Gömme modeli',
    payment: 'Ödeme',
    invoice: 'Fatura',
    push: 'Push',
    email: 'E-posta',
  },
  columns: {
    id: 'Kimlik',
    name: 'Ad',
    registered: 'Kayıtlı sürüm',
    pinned: 'Sabitlenen sürüm',
    liveTest: 'Canlı test',
    environments: 'Ortamlar',
    rule: 'İşletme kuralı',
    health: 'Sağlık',
    connections: 'Bağlantılar',
    errorRate: 'Hata oranı (24 saat)',
    expiring: 'Süresi dolacak kimlik bilgisi',
    alerts: 'Açık uyarı',
    lastEvent: 'Son olay',
  },
  mismatch: 'Uyumsuz',
  rule: {
    all: 'Tümü',
    allow: 'İzin listesi',
    deny: 'Engel listesi',
    allowCount: 'İzin listesi ({count})',
    denyCount: 'Engel listesi ({count})',
  },
  connections: '{active} etkin, {degraded} sorunlu, {error} hatalı, {disconnected} kopuk / {total}',
  computedAt: 'Hesaplanma: {at}',
  sheet: {
    health: 'Sağlık',
    attempts: 'Deneme (24 saat)',
    failures: 'Başarısız (24 saat)',
    expiring: 'Süresi dolacak kimlik bilgileri',
    expiringNone: 'Süresi dolacak kimlik bilgisi yok.',
    expiresAt: '{merchant}: {at}',
    openAlerts: 'Açık uyarılar',
    computedAt: 'Hesaplanma zamanı',
    openAlertsLink: '{count} açık uyarıyı gör',
    edit: 'Ayarlar',
    merchants: 'İşletmeler',
    none: 'Yok',
    disableNote:
      'Bir ortamı veya işletmeyi kapatmak yalnızca yeni bağlantıları durdurur; mevcut bağlantılar çalışmaya devam eder.',
    save: 'Kaydet',
  },
  // The live-test line of a registry entry (admin screens §3.8, D-134).
  liveTest: {
    passed: 'Canlı test: geçti {date}',
    none: 'Canlı test: yok',
  },
  confirm: {
    title: 'Değişikliği onayla',
    environment: 'Bu adaptör {ortam} ortamında bağlanabilir hale gelir.',
    mismatch: 'Sürüm uyuşmazlığı adaptörü devre dışı bırakır ve uyarı açar.',
    confirm: 'Kaydet',
    noLiveTest: 'Bu adaptörün canlı testi yok.',
  },
} as const satisfies CatalogTree;
